import React from 'react'
import { FeatureContainer, FeatureButton } from './FeatureElements' 


const Feature = () => {
    return (
      <FeatureContainer>
          <h1>Food Recipe Of The Day</h1>
          <p>Come and try This Out</p>
          <FeatureButton>Order Now</FeatureButton>
      </FeatureContainer>
    )
}

export default Feature
